// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notices[data-v-7e74ced5]{font-size:.75rem;font-weight:400;color:#e70095;margin-bottom:.5em}.notices p[data-v-7e74ced5]{margin:0;display:flex;grid-gap:10px;gap:10px}.notices p .app-icon[data-v-7e74ced5]{position:relative;top:2px;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
